import React from 'react';

import { ButtonHome } from 'Components/ButtonHome';
import ButtonReload from 'Components/ButtonReload';
import { Error } from 'Components/Errors/Error';

export const RequestError = () => (
  <Error reason="RequestError">
    <ButtonReload />
    <ButtonHome
      linkText={'Ir a\ninicio'}
      openInSelf
    />
  </Error>
);
